angular.module('shbdeployer.integrations.storidge').controller('StoridgeSnapshotController', [
  '$scope',
  '$state',
  '$transition$',
  'Notifications',
  'ModalService',
  'StoridgeSnapshotService',
  function ($scope, $state, $transition$, Notifications, ModalService, StoridgeSnapshotService) {
    $scope.removeSnapshot = function () {
      ModalService.confirm({
        title: 'Вы уверены?',
        message: 'Удалить этот снимок?',
        buttons: {
          confirm: {
            label: 'Удалить',
            className: 'btn-danger',
          },
        },
        callback: function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          StoridgeSnapshotService.remove($scope.snapshot.Id)
            .then(function () {
              Notifications.success('Готово', 'Снимок удален');
              $state.go('docker.volumes.volume', { id: $scope.volumeId });
            })
            .catch(function error(err) {
              Notifications.error('Ошибка', err, 'Не удалось удалить снимок');
            });
        },
      });
    };

    function initView() {
      $scope.volumeId = $transition$.params().id;
      $scope.snapshotId = $transition$.params().snapshotId;

      StoridgeSnapshotService.snapshot($scope.snapshotId)
        .then(function success(data) {
          $scope.snapshot = data;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения о снимке');
        });
    }

    initView();
  },
]);
